import {
  FormControlLabel,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from '@mui/material';
import { forwardRef } from 'react';
import { withTestId } from '../../../../lib/testId.utils';

type Props = Pick<
  MuiSwitchProps,
  | 'checked'
  | 'defaultChecked'
  | 'disabled'
  | 'onChange'
  | 'onBlur'
  | 'size'
  | 'name'
  | 'id'
  | 'required'
  | 'value'
  | 'slotProps'
  | 'className'
  | 'sx'
> & {
  label?: React.ReactNode;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  testId?: string;
};

const Switch = forwardRef<HTMLButtonElement, Props>(
  (
    {
      label,
      labelPlacement = 'end',
      className,
      sx,
      checked,
      defaultChecked,
      disabled,
      onChange,
      onBlur,
      size,
      name,
      id,
      required,
      value,
      slotProps,
      testId,
    },
    ref,
  ) => {
    const inputProps = {
      checked,
      defaultChecked,
      disabled,
      onChange,
      onBlur,
      size,
      name,
      id,
      required,
      value,
      slotProps: withTestId(slotProps, 'input', testId),
    };

    if (label !== undefined) {
      return (
        <FormControlLabel
          control={<MuiSwitch {...inputProps} ref={ref} />}
          label={label}
          labelPlacement={labelPlacement}
          className={className}
          sx={sx}
        />
      );
    }

    return <MuiSwitch {...inputProps} ref={ref} className={className} sx={sx} />;
  },
);

Switch.displayName = 'Switch';
export type { Props as SwitchProps };
export default Switch;
